import { createFetchAction } from '@mews-commander/utils';
import {
    hasAccountingConfigurationFetchFailed,
    ACCOUNTING_CONFIGURATION_FETCH,
} from '../ducks/accountingConfigurations';
import { setServices } from '../ducks/services';

export const fetchAccountingConfiguration =
    (enterpriseId: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        if (hasAccountingConfigurationFetchFailed(getState(), { enterpriseId })) {
            return;
        }

        const promise = container()
            .accountingConfigurationComponent.get({ enterpriseId, extent: { services: true } })
            .then(({ accountingConfiguration, services }: $TSFixMe) => {
                dispatch(setServices(services));
                return accountingConfiguration;
            });
        return dispatch(createFetchAction(ACCOUNTING_CONFIGURATION_FETCH, promise, { scope: enterpriseId }));
    };
